
export enum GridConnectionMethodType {
  SUBSTATION = 'SUBSTATION',
  TRANSFER_STATION = 'TRANSFER_STATION',
  OTHER = 'OTHER',
}
export const gridConnectionMethodTypeToLabel = {
  [GridConnectionMethodType.SUBSTATION]: 'Substation',
  [GridConnectionMethodType.TRANSFER_STATION]: 'Transfer Station',
  [GridConnectionMethodType.OTHER]: 'Other',
};
